import { VOLUME_DAILY,STAKING_DAILY,AUM_DAILY,FEE_DAILY,PNL_DAILY,YLP_DAILY,YLP_PRICEDAILY,YORROWING_DAILY,MARKETS,VOLUME_DAILY_MARKETS_DEFAULT,STAKING_DAILY_MARKETS_DEFAULT,AUM_DAILY_MARKETS_DEFAULT,FEE_DAILY_MARKETS_DEFAULT,PNL_DAILY_MARKETS_DEFAULT,YLP_DAILY_MARKETS_DEFAULT,YLP_PRICEDAILY_MARKETS_DEFAULT,YORROWING_DAILY_MARKETS_DEFAULT } from '../actionType'
const initialState = {
    
    // volumeData: {},
    // stakingData: {},
  };
export const chartData = ( state = initialState, action ) =>{
    const { type, data } = action
    switch (type) {
        case VOLUME_DAILY:
            return {
                ...state,
                VOLUME_DAILY: data,
            };
        case STAKING_DAILY:
            return {
                ...state,
                STAKING_DAILY: data,
            };
        case AUM_DAILY:
            return {
                ...state,
                AUM_DAILY: data,
            };
        case FEE_DAILY:
            return {
                ...state,
                FEE_DAILY: data,
            };
        case PNL_DAILY:
            return {
                ...state,
                PNL_DAILY: data,
            };
        case YLP_DAILY:
            return {
                ...state,
                YLP_DAILY: data,
            };
        case YLP_PRICEDAILY:
            return {
                ...state,
                YLP_PRICEDAILY: data,
            };
        case YORROWING_DAILY:
            return {
                ...state,
                YORROWING_DAILY: data,
            };
        case MARKETS:
            return {
                ...state,
                MARKETS: data,
            };
        case VOLUME_DAILY_MARKETS_DEFAULT:
            return {
                ...state,
                VOLUME_DAILY_MARKETS_DEFAULT: data,
            };
            
        default:
          return state;
      }
    // switch (type) {
    //     case CHARTtDATA:
    //         return data
    //     default:
    //         return preState || null
    // }
}